
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/content_wall/behaviors/templates/moments_wall_navigation"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"day-view-previousMoment\"></div>\n<h2 class=\"sr-only\">Moments</h2>\n<div class=\"day-view-nextMoment\"></div>\n";
},"useData":true});
    }).call(this);
  